<fieldset
  class="toggle"
  [ngClass]="{ 'toggle--full': config.isFullWidth }"
  [attr.prop]="config.prop"
  role="group"
  [attr.aria-label]="config.label"
>
  @for (option of config.options; track option) {
    <div
      class="toggle__option"
      [ngClass]="{ 'is-active': option.value === value }"
      [attr.readonly]="getReadonlyStatus(config, option)"
      (click)="onOptionClick(option)"
      (keydown.enter)="onOptionClick(option)"
      [attr.role]="'switch'"
      [attr.aria-label]="option.label"
      [attr.aria-checked]="option.value === value"
      tabindex="0"
      [attr.aria-describedby]="(config?.id || config?.prop) + '-label'"
      [attr.aria-errormessage]="
        'error_' + (config?.id || config?.prop) + '-input'
      "
      [attr.aria-invalid]="(control.dirty || control.touched) && !control.valid"
      [attr.data-test-id]="getDataTestId(config, option)"
    >
      @if (option.icon) {
        <icon class="toggle__icon" [name]="option.icon"></icon>
      }
      @if (option.label) {
        <p class="toggle__label">{{ option.label }}</p>
      }
    </div>
  }
</fieldset>
